import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"
import _imports_0 from '@/app/ui/assets/svg/topup-white-admin.svg'


const _hoisted_1 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_2 = { class: "border text-12px text-red-lp-100 p-4 rounded-b-md border-red-lp-100" }
const _hoisted_3 = {
  key: 1,
  class: "bg-blue-lp-100 border p-4 rounded flex flex-row my-4"
}
const _hoisted_4 = /*#__PURE__*/_createVNode("img", {
  src: _imports_0,
  class: "w-6 max-w-none",
  alt: "coin-red"
}, null, -1)
const _hoisted_5 = { class: "text-12px text-white mt-1 ml-2 font-normal" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Biaya Top Up sebesar ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" otomatis dipotong melalui saldo Anda ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.isAnyCashbackConfigActive)
      ? (_openBlock(), _createBlock("div", _hoisted_1, [
          _createVNode("img", {
            src: require(`@/app/ui/assets/images/banner-cashback.png`),
            alt: "info",
            class: "cursor-pointer",
            onClick: _cache[1] || (_cache[1] = () => _ctx.setShowModalDetailCashback(true))
          }, null, 8, ["src"]),
          _createVNode("div", _hoisted_2, " *Periode Program " + _toDisplayString(_ctx.startDateCashback) + " s/d " + _toDisplayString(_ctx.endDateCashback), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.isAnyTopupFeeConfigActive)
      ? (_openBlock(), _createBlock("div", _hoisted_3, [
          _hoisted_4,
          _createVNode("div", _hoisted_5, [
            _hoisted_6,
            _createVNode("b", null, _toDisplayString(_ctx.formatTopupFee), 1),
            _hoisted_7
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}